var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',_vm._g(_vm._b({staticClass:"filter",attrs:{"items":_vm.items,"label":_vm.label,"item-text":"name","item-value":"id","multiple":"","rounded":"","outlined":"","dense":"","append-icon":"mdi-chevron-down"}},'v-select',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }